import cn from 'classnames'
import parse from 'html-react-parser'

function JournalEntryHeading({
  classNames,
  chosenEmoji,
  prompt,
  handleShowEmojiPicker
}) {
  return (
    <div
      className={cn(
        'journal-top-container d-flex justify-content-between align-items-center gap-3 px-1',
        classNames
      )}
    >
      <div className='journal-prompt'>
        <h5 className='text-nowrap mb-0'>{prompt && parse(prompt)}</h5>
      </div>
      <div
        className='journal-emoji cursor-pointer align-center flex-wrap'
        onClick={handleShowEmojiPicker}
      >
        <span>
          {chosenEmoji}
          &nbsp;
        </span>
        <span className='text-right small'>Choose Emoji</span>
      </div>
    </div>
  )
}

export default JournalEntryHeading
